<template>
  <div>
    <!-- Voucher Header Info Card -->
    <b-card
      v-if="$store.state.voucherUsageV2.voucherData"
      class="mb-2"
    >
      <div class="d-flex align-items-center w-100">
        <div class="flex-grow-1">
          <div class="d-flex align-items-center mb-1">
            <feather-icon
              icon="GiftIcon"
              size="16"
              class="mr-50"
            />
            <h4 class="mb-0 mr-2">
              {{ $store.state.voucherUsageV2.voucherData.name || 'Voucher' }}
            </h4>
            <!-- Status Badge -->
            <b-badge
              :variant="$store.state.voucherUsageV2.voucherData.is_active ? 'success' : 'secondary'"
              pill
              class="mr-1"
            >
              {{ $store.state.voucherUsageV2.voucherData.is_active ? 'Aktif' : 'Tidak Aktif' }}
            </b-badge>
          </div>
          <div class="d-flex align-items-center mb-50">
            <p class="mb-0">
              <span class="text-muted">Kode Voucher:</span> {{ $store.state.voucherUsageV2.voucherData.code || '-' }}
            </p>
            <p class="text-muted mb-0 mx-1">
              |
            </p>
            <p class="mb-0">
              <span class="text-muted">Tipe Potongan:</span> {{ getVoucherTypeLabel($store.state.voucherUsageV2.voucherData.type) }}
            </p>
          </div>
          <div class="d-flex align-items-center mb-50">
            <p class="mb-0">
              <span class="text-muted">Diskon:</span> {{ formatDiscount($store.state.voucherUsageV2.voucherData.discount) }}
            </p>
            <p class="text-muted mb-0 mx-1">
              |
            </p>
            <p class="mb-0">
              <span class="text-muted">Maksimal Potongan:</span> {{ formatCurrency($store.state.voucherUsageV2.voucherData.max_discount) }}
            </p>
          </div>
        </div>
      </div>
    </b-card>

    <Table
      resource="VoucherV2"
      :actions="actions"
      :items="$store.getters['voucherUsageV2/tableData']"
      :detail="$store.getters['voucherUsageV2/detailData']"
      :detail-route="row => `/transactions/${row.id}/detail`"
      :fields="$store.getters['voucherUsageV2/tableFields']"
      :pagination="$store.state.voucherUsageV2.tablePagination"
      :keyword="$store.state.voucherUsageV2.tableKeyword"
      :loading="$store.state.voucherUsageV2.loadingTable"
      :filter="$store.state.voucherUsageV2.tableFilter"
      :sort="$store.state.voucherUsageV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    >
      <!-- Custom cell: invoice_number with date below -->
      <template #cell-invoice_number="{ data }">
        <div class="mb-25 d-flex align-items-center flex-nowrap">
          <a
            :href="`/transactions/${data.item.id}/detail`"
            target="_blank"
            class="font-weight-bold"
          >
            {{ data.item.invoice_number ? data.item.invoice_number : '-' }}
          </a>
          <feather-icon
            v-b-tooltip.hover.top="'Salin No Invoice'"
            icon="CopyIcon"
            size="16"
            class="copy-btn ml-25"
            @click.stop="onCopy(data.item.invoice_number, 'No Invoice')"
          />
        </div>
        <small>
          {{ data.item.accepted_at ? formatDate(data.item.accepted_at) : formatDate(data.item.created_at) }}
          {{ data.item.accepted_at ? formatTime(data.item.accepted_at) : formatTime(data.item.created_at) }}
        </small>
      </template>
    </Table>
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'
import { BBadge, BCard } from 'bootstrap-vue'

export default {
  components: {
    Table,
    BBadge,
    BCard,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'view',
      ],
    }
  },
  mounted() {
    this.loadData()
    this.loadVoucherDetail()
  },
  methods: {
    loadData() {
      const { id } = this.$route.params
      return this.$store.dispatch('voucherUsageV2/getTableData', id)
    },
    loadVoucherDetail() {
      const { id } = this.$route.params
      return this.$store.dispatch('voucherUsageV2/getVoucherDetail', id)
    },
    getVoucherTypeLabel(type) {
      const typeMap = {
        regular: 'Produk',
        shipping: 'Ongkir',
      }
      return typeMap[type] || type || '-'
    },
    formatDiscount(discount) {
      if (!discount) return '-'
      return `${discount}%`
    },
    formatCurrency(amount) {
      if (!amount) return '-'
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount)
    },
    loadDetail() {
      return Promise.resolve()
    },
    resetDetail() {
      this.$store.commit('voucherUsageV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('voucherUsageV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('voucherUsageV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('voucherUsageV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('voucherUsageV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('voucherUsageV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('voucherUsageV2/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
